import moment, { Moment } from 'moment';

export const getTimestamp = (time: Moment | string, format = 'YYYY-MM-DD HH:mm:ss') =>
  moment.isMoment(time) ? time.format(format) : moment(time).format(format);

export const getUtcTimestamp = (time: string | Moment = moment()) => getTimestamp(moment.utc(time));
